<div class="spl-ui-not-found-feature">
  <div>
    <img src="splitory-ui/assets/images/page-not-found.svg" alt="" />
  </div>

  <h1>Oooops! Page Not Found</h1>
  <p>This page doesn't exist or was removed</p>

  <a matButton="filled" [routerLink]="fallbackPath | async">
    <mat-icon splUiIcon="home"></mat-icon>

    Bring me back to civilization!
  </a>
</div>
